var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3787 51.0465C12.3791 51.0463 12.3793 51.0459 12.3793 51.0454C12.3479 44.1085 13.8402 37.8766 16.8397 32.0093C18.7956 28.184 21.2957 24.7478 24.3061 21.6782C27.0907 18.8393 30.2021 16.4275 33.6483 14.4489C38.4499 11.692 43.5959 9.93046 49.0819 9.17107C51.5858 8.82418 54.1037 8.69993 56.6278 8.81093C62.3559 9.06259 67.8186 10.3972 72.9942 12.8784C77.4439 15.0121 81.4016 17.839 84.851 21.3653C89.8154 26.4401 93.314 32.3833 95.3455 39.1893C96.2626 42.2616 96.8132 45.3962 97.0446 48.5927C97.4937 54.7926 96.5905 60.7863 94.3168 66.5681C92.634 70.8468 90.2941 74.739 87.3329 78.2571C83.2156 83.1477 78.2594 86.9477 72.4663 89.6478C68.7394 91.3848 64.8365 92.5441 60.7627 93.1306C58.1648 93.5046 55.5556 93.6434 52.9362 93.5292C47.6893 93.3009 42.6454 92.1669 37.8249 90.0666C33.0731 87.9966 28.8416 85.1521 25.1374 81.5261C21.1072 77.581 17.9845 73.0146 15.7763 67.8238C14.2506 64.2363 13.2377 60.5107 12.7445 56.6425C12.4929 54.6699 12.3636 52.6922 12.378 51.0475C12.3781 51.0471 12.3783 51.0467 12.3787 51.0465ZM54.8996 86.0767C54.8996 86.0771 54.8999 86.0773 54.9002 86.0773C57.6909 86.0931 60.4362 85.7436 63.1355 85.0575C67.471 83.9562 71.4433 82.0717 75.0611 79.4422C79.9939 75.8572 83.8154 71.335 86.4417 65.827C88.7375 61.0115 89.8211 55.9355 89.6117 50.592C89.5089 47.9689 89.1556 45.3823 88.4984 42.8418C86.827 36.377 83.6438 30.7775 78.8668 26.0969C76.0406 23.3281 72.8327 21.1099 69.2396 19.453C64.4177 17.2297 59.3499 16.1991 54.0418 16.3291C51.3632 16.3947 48.7262 16.7479 46.1308 17.4107C40.7634 18.7825 35.9901 21.2947 31.8135 24.9276C28.2828 27.9992 25.4755 31.6378 23.3966 35.8339C21.5543 39.5533 20.4247 43.4776 20.0223 47.6075C19.7757 50.136 19.83 52.6633 20.1264 55.1868C20.5591 58.8658 21.5234 62.3952 23.0731 65.7607C25.7133 71.4946 29.6205 76.1808 34.8019 79.7803C40.8376 83.9732 47.5627 86.0129 54.899 86.0761C54.8993 86.0761 54.8996 86.0764 54.8996 86.0767Z",
    fill: "url(#paint0_linear_0_1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.2815 43.0193C70.2814 43.0192 70.2812 43.0192 70.2812 43.0194C70.2635 44.1148 69.9494 44.956 69.3124 45.639C68.3096 46.7143 67.2765 47.7626 66.2377 48.8033C61.6726 53.3772 57.1043 57.9486 52.5253 62.5087C52.0744 62.9578 51.5723 63.3728 51.0393 63.7197C49.6991 64.5907 48.3557 64.5541 47.0873 63.5702C46.3191 62.9742 45.6171 62.2861 44.9258 61.5986C43.0267 59.709 41.134 57.8118 39.2683 55.8894C38.2617 54.8525 37.7596 53.6062 38.1248 52.1473C38.6445 50.0691 40.8842 48.6368 43.1989 49.7411C43.7199 49.9896 44.2131 50.3485 44.6325 50.7471C46.0409 52.0861 47.4108 53.4662 48.7953 54.8304C49.1188 55.1495 49.1617 55.1489 49.4745 54.8367C53.2109 51.1129 56.9441 47.3867 60.6861 43.6692C61.8334 42.5295 62.963 41.3652 64.1803 40.3031C65.3661 39.2681 66.7732 39.1376 68.191 39.7992C69.5974 40.455 70.1985 41.6658 70.2818 43.0191C70.2818 43.0193 70.2816 43.0194 70.2815 43.0193Z",
    fill: "url(#paint1_linear_0_1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0.376953,
    y: 0.771484,
    width: 108.779,
    height: 108.797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 26.0059,
    y: 31.3926,
    width: 56.276,
    height: 48.9502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 3.89229,
    y1: -17.9347,
    x2: 123.38,
    y2: -8.69533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3295BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A78C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 34.7757,
    y1: 31.5348,
    x2: 80.0836,
    y2: 36.0679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3295BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A78C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.529a8ed73b83dacbd781b88eb4eafc21.svg";
export { ForwardRef as ReactComponent };